import React from 'react';
import PropTypes from 'prop-types';

import Button from 'src/components/Button';

import theme from 'src/styles/components/QuantityChecker.module.scss';

const QuantityChecker = ({
    configurablePosition,
    position,
    increaseQuantity,
    decreaseQuantity,
    shouldQuantityZeroRemove
}) => (
    <div className={theme.container}>
        <div className={theme.quantityContainer}>
            <Button
              className={theme.addIcon}
              floating
              mini
              inverse
              iconSmall
              icon="icon-minus"
              disabled={configurablePosition?.minQuantity === configurablePosition?.quantity && !shouldQuantityZeroRemove}
              onClick={() => { decreaseQuantity(configurablePosition, position); }}
            />
            <div className={theme.quantity}>
                {configurablePosition && configurablePosition.quantity}
            </div>
            <Button
              className={theme.addIcon}
              floating
              mini
              inverse
              iconSmall
              icon="icon-plus"
              disabled={configurablePosition?.maxQuantity === configurablePosition?.quantity}
              onClick={() => { increaseQuantity(configurablePosition, position); }}
            />
        </div>
    </div>
);

QuantityChecker.propTypes = {
    position: PropTypes.number,
    configurablePosition: PropTypes.shape({
        id: PropTypes.string.isRequired,
        price: PropTypes.number,
        quantity: PropTypes.number,
        minQuantity: PropTypes.number,
        maxQuantity: PropTypes.number
    }),
    increaseQuantity: PropTypes.func.isRequired,
    decreaseQuantity: PropTypes.func.isRequired,
    shouldQuantityZeroRemove: PropTypes.bool
};

export default QuantityChecker;
